export default __webpack_public_path__ + "static/media/full-screen.d696a2cb.svg";